import { render, staticRenderFns } from "./RoleMag.vue?vue&type=template&id=a3e41b28&"
import script from "./RoleMag.vue?vue&type=script&lang=js&"
export * from "./RoleMag.vue?vue&type=script&lang=js&"
import style0 from "./RoleMag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports